import { render, staticRenderFns } from "./OrganizationsPrepayments.vue?vue&type=template&id=0e2d4c7b&"
import script from "./OrganizationsPrepayments.vue?vue&type=script&lang=js&"
export * from "./OrganizationsPrepayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports